import { useRef } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';

import { MultiInputItem } from './multi-input-item';
import { MultiInputValue } from './multi-input-value';
import { Content, InputBox, Popup } from './multi-input.styled';

/**
 * data - {id: string, name: string, ...}
 */
export const MultiInput = (props) => {
  const { countDisplayedIcons = 5, maxValuesShow, itemCmp, valueCmp, showPopup, values, setValue, data, $popupIsOpen, popupIsOpen, width, minWidth, selectAll } = props;
  const open = $popupIsOpen || popupIsOpen;
  const wrapper = useRef(null);
  const ItemCmp = itemCmp ?? MultiInputItem;
  // console.log('🚀 ~ MultiInput ~ width, minWidth:', props.input?.name, width, minWidth);
  const ValueCmp = valueCmp ?? MultiInputValue;

  /**
   * get inputs
   * @returns
   */
  const getInputsEl = () => {
    if (Array.isArray(data)) {
      return data.map((elem) => {
        if (!elem.id) {
          return null;
        }
        const { name, id, ...rest } = elem;
        // console.log("rest", rest);
        const checked = values?.includes(elem);
        return <ItemCmp key={id} onChange={(e) => setValue(e, id)} name={name} checked={checked} {...rest} />;
      });
    }
  };

  /**
   * outside click
   * @param {*} event
   */
  const outsideClick = (event) => {
    if (!wrapper.current.contains(event.target)) {
      if (open) {
        showPopup();
      }
    }
  };

  const inputsEl = getInputsEl();
  return (
    <Content ref={wrapper} className="mi-content">
      <InputBox onClick={showPopup} className={open ? 'input open' : 'input'} $popupIsOpen={open}>
        <ValueCmp values={values} maxValues={countDisplayedIcons} maxValuesShow={maxValuesShow} minWidth={width || minWidth} placeholder={props.placeholder} />
      </InputBox>
      <OutsideClickHandler onOutsideClick={outsideClick}>
        <Popup className="popup" $popupIsOpen={open} minWidth={width || minWidth}>
          <MultiInputItem
            className="item-all"
            name="Все"
            onChange={selectAll}
            checked={values.length === data.length}
            indeterminate={values.length > 0 && values.length < data.length}
          />
          {inputsEl}
        </Popup>
      </OutsideClickHandler>
    </Content>
  );
};
